export const getFirstMonthlyPayments = (quoteResponse, monthlyPayment) => {
    const monthlyPaymentSelected = quoteResponse.map(
        quote => quote.monthlyPayments.find(
            monthlyPaymentItem => !!monthlyPayment.value ?
                monthlyPaymentItem.term === monthlyPayment.value :
                monthlyPaymentItem.selected
        )
    ).pop();
    return {
        id: monthlyPaymentSelected.term || monthlyPaymentSelected.id,
        value: monthlyPaymentSelected.term || monthlyPaymentSelected.value,
        label: [
            `${monthlyPaymentSelected.term || monthlyPaymentSelected.id} pagos de`,
            monthlyPaymentSelected.monthlyQuota ?
                monthlyPaymentSelected.monthlyQuota.displayValue : monthlyPaymentSelected.label[1]
        ]
    };
};

export const getCatalogHouseHoldMeasure = (lapse, state) => {
    return state.catalogs.lapse.find(item => item.value === lapse);
};

export const getCatalogHouseHoldTime = (root) => {
    const rootMappedId = root.length === 1 ? `0${root}` : root;
    return {id: rootMappedId, value: root};
};